import { useEffect, useRef } from "react";

export const useInfiniteScroll = (onLoadMore, hasMore, isFetching) => {
  const ref = useRef(null);
  

  useEffect(() => {
    if (!ref.current || !hasMore || isFetching) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isFetching) {
          onLoadMore();
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [hasMore, isFetching, onLoadMore]);

  return ref;
};

export default useInfiniteScroll;
